// AI Generated Test
import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { SeoRepoService } from '../../services/seo-repo.service';
import { ENTITY_CONSTANT } from '@client/app/core/constants/entity.constant';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { LabelService } from '@client/ng2/services/label-service/label.service';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-from-seo-issues',
    templateUrl: './pages-from-seo-issues.component.html',
    standalone: false,
})
export class PagesFromSeoIssuesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    @Input() issue: any = null;
    @Input() pageCount: number = 0;

    pages: any = [];
    progress: Promise<any> | null = null;
    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    override isFiltersOpen: boolean = false;
    exports: any[] = [];
    private eventId: number = 0;
    private baseEntityService = inject(BaseEntityService);
    private activeFeatureService = inject(ActiveFeatureService);
    private labelService = inject(LabelService);

    constructor (
        private seoRepoService: SeoRepoService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.init();
    }

    ngOnDestroy (): void {
        this.onDestroy();
    }

    init (): void {
        if (this.monEventsService && this.baseEntityService) {
            this.eventId = this.monEventsService.addListener(
                ENTITY_CONSTANT.PAGE_UPDATED_EVENT as any,
                this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
            );
        }

        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pages = [];
        this.currentSort = { by: 'priority_score', direction: 'desc' };
        this.getPage();
        this.getLabels();
        this.isFiltersOpen = false;
        this.exports = [
            {
                data: {
                    category: 'seo',
                    category_ref: this.issue.name,
                },
            },
        ];
    }

    override getPage (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            status: this.activeTab,
            issue_id: this.issue.id,
            sort_by: this.currentSort.by === 'notification_count' ? 'seo_issues_count' : this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        if (this.search && this.search !== '') {
            params.search = this.search;
        }

        this.updateParamsWithFilters(params);

        this.progress = this.seoRepoService.getSeoIssuePages(this.issue.id, params).then((data: any) => {
            this.pages = data;
            return data;
        }).catch(() => {
            // Handle error silently
        });
    }

    onFiltersChanged (changes: any): void {
        this.updateFilters(changes);
        this.getPage();
    }

    onSearchChanged (search: string): void {
        this.search = search;
        this.getPage();
    }

    override onPageDetailsClose (): void {
        this.getPage();
    }

    private onDestroy (): void {
        if (this.monEventsService && this.eventId) {
            this.monEventsService.remove(this.eventId);
        }
    }

    createOrUpdateLabel (label: any): void {
        this.labelService.createOrUpdateLabel(label);
    }

    override onSearch (searchTerm: string): void {
        this.onSearchChanged(searchTerm);
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

}
